var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
export var customWaterfallPlugin = {
    id: 'waterfall',
    beforeInit: function (chart, _, options) {
        var _a = chart.data, datasets = _a.datasets, labels = _a.labels;
        var _b = options.datasetReferenceIndex, datasetReferenceIndex = _b === void 0 ? 0 : _b, summaryLabel = options.summaryLabel, summaryBackgroundColor = options.summaryBackgroundColor;
        var compareReferenceIndex = datasetReferenceIndex === 0 ? 1 : 0;
        var referenceDataset = datasets[datasetReferenceIndex];
        var compareDataset = datasets[compareReferenceIndex];
        var resultDatasetObj = {
            data: __spreadArray([], referenceDataset.data, true),
            backgroundColor: Array.from({ length: referenceDataset.data.length }).fill(compareDataset.backgroundColor),
            label: summaryLabel,
        };
        var previousValue = 0;
        resultDatasetObj.data = resultDatasetObj.data.map(function (value, index) {
            var _a;
            var referenceDataVal = value === undefined ? 0 : Number.parseFloat(value === null || value === void 0 ? void 0 : value.toString());
            var currDatasetVal = value === undefined
                ? 0
                : Number.parseFloat((_a = compareDataset.data[index]) === null || _a === void 0 ? void 0 : _a.toString());
            var differenceVal = referenceDataVal - currDatasetVal;
            var maximumValue = previousValue + differenceVal;
            var newValue = [previousValue, maximumValue];
            if (currDatasetVal > referenceDataVal)
                resultDatasetObj.backgroundColor[index] =
                    referenceDataset.backgroundColor;
            previousValue = maximumValue;
            return newValue;
        });
        if (summaryLabel && summaryBackgroundColor) {
            resultDatasetObj.backgroundColor.push(summaryBackgroundColor);
            resultDatasetObj.data.push([previousValue, 0]);
            if (!(labels === null || labels === void 0 ? void 0 : labels.some(function (el) { return el === summaryLabel; })))
                labels === null || labels === void 0 ? void 0 : labels.push(summaryLabel);
        }
        // Push the resultant dataset
        datasets.push(resultDatasetObj);
        // Hide other datasets
        datasets[0].hidden = true;
        datasets[1].hidden = true;
    },
    beforeDestroy: function (chart, _, options) {
        var labels = chart.data.labels;
        var summaryLabel = options.summaryLabel;
        // Summary clean up
        var summaryLabelIndex = labels === null || labels === void 0 ? void 0 : labels.findIndex(function (el) { return el === summaryLabel; });
        if (summaryLabelIndex && summaryLabelIndex !== -1)
            labels === null || labels === void 0 ? void 0 : labels.splice(summaryLabelIndex);
    },
};
